import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { isOutsideClick } from '@utils/safeTs'
import styles from './WModal.module.sass'

interface Props {
  id: string
  ariaLabel?: string
  ariaLabelledby?: string
  open: boolean
  onClose?: (v?: React.MouseEvent<HTMLButtonElement | HTMLDivElement>) => void
  className?: string
  children?: ReactNode
}

const WModal = (props: Props) => {
  const {
    id,
    ariaLabel = undefined,
    ariaLabelledby = undefined,
    open = false,
    onClose = undefined,
    className = '',
    children = null,
  } = props

  const [prevActiveElement, setPrevActiveElement] = useState(null)
  const ref = useRef(null)

  useEffect(() => {
    const keyDownHandler = (event) => {
      if (event.key === 'Escape') {
        event.preventDefault()
        if (onClose) onClose()
      }
    }
    document.addEventListener('keydown', keyDownHandler)
    return () => document.removeEventListener('keydown', keyDownHandler)
  }, [])

  useEffect(() => {
    if (open) document.body.classList.add('w-noscroll')
    else document.body.classList.remove('w-noscroll')

    if (open) {
      if (ref.current) {
        // Salvo l'elemento che aveva il focus prima
        setPrevActiveElement(document.activeElement)

        ref.current.showModal()
        if (onClose) {
          // Listener per click fuori dai bounds (backdrop)
          const handleBackdropClick = (e) => {
            if (isOutsideClick(e, ref)) {
              onClose()
            }
          }
          ref.current.addEventListener('click', handleBackdropClick)
          return () => ref.current?.removeEventListener('click', handleBackdropClick)
        }
      }
    } else {
      // rimetto il focus sull'elemento che aveva il focus prima
      if (prevActiveElement) prevActiveElement.focus()
    }
  }, [open])

  return open ? (
    <dialog
      className={`${styles.root} ${className}`}
      hidden={!open}
      aria-modal
      aria-label={ariaLabelledby ? undefined : ariaLabel}
      aria-labelledby={ariaLabelledby}
      ref={ref}
      id={id}
    >
      {children}
    </dialog>
  ) : (
    <></>
  )
}

export default WModal
